module.exports = __webpack_public_path__ + "static/media/light.0c6aee16.png";